var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBen3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10911",
    "data-name": "Group 10911",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.696,
    height: 58.957,
    viewBox: "0 0 73.696 58.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10912",
    "data-name": "Group 10912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14399",
    "data-name": "Path 14399",
    d: "M68.326,18.739H57.272V11.37A7.391,7.391,0,0,0,49.9,4H27.794a7.391,7.391,0,0,0-7.37,7.37v7.37H9.37A7.391,7.391,0,0,0,2,26.109V62.957H75.7V26.109A7.391,7.391,0,0,0,68.326,18.739ZM27.794,11.37H49.9v7.37H27.794ZM68.326,55.587H9.37V44.533h7.37v3.685h7.37V44.533H53.587v3.685h7.37V44.533h7.37Zm-7.37-18.424V33.478h-7.37v3.685H24.109V33.478h-7.37v3.685H9.37V26.109H68.326V37.163Z",
    transform: "translate(-2 -4)",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBen3);
export default __webpack_public_path__ + "static/media/ben_3.66123f501dfe2a1c6c4b1997c2930623.svg";
export { ForwardRef as ReactComponent };